var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetterLuck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
    fill: "#3986E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4132 46.0429L53.0844 29.5425L52.149 28.9536L38.8329 15.6743L35.3851 17.0999L33.2425 35.8877L25.4624 28.6556L17.2109 45.1918L17.2363 51.4939L36.5851 70.9819C52.0439 70.5187 65.0228 60.1696 69.4132 46.0429Z",
    fill: "#0B59B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.243 35.6722C52.8781 35.2916 54.0962 33.8265 54.0962 32.0777C54.0962 30.0811 52.5119 28.458 50.5325 28.3898V28.3754H40.5372C40.5372 28.3754 42.2121 16.59 37.5897 14.8268C36.745 14.5037 35.7843 14.6257 35.0701 15.1823C32.8731 16.9024 34.3813 21.3659 33.1269 24.1561C31.1003 28.2641 29.0737 29.5533 28.2942 29.9195C28.0875 30.0165 27.957 30.2212 27.957 30.451V48.9228C27.957 49.465 28.4066 50.0108 28.9721 50.4777C30.0598 51.379 31.4338 51.8566 32.8477 51.8566H46.2001V51.853C47.5632 51.8243 48.6617 50.7111 48.6617 49.3393C48.6617 48.6283 48.3645 47.9855 47.8895 47.5295C49.6152 47.4469 50.9893 46.0249 50.9893 44.2761C50.9893 43.3461 50.5977 42.5094 49.9741 41.9169C50.0213 41.9205 50.0648 41.924 50.1119 41.924C51.8231 41.924 53.2116 40.4733 53.2116 38.685C53.2116 37.3133 52.3923 36.1462 51.243 35.6722Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7698 51.8566H18.0809C17.4319 51.8566 16.9062 51.3324 16.9062 50.6824V29.6C16.9062 28.9536 17.4319 28.4258 18.0809 28.4258H24.7661C25.4151 28.4258 25.9408 28.9501 25.9408 29.6V50.6824C25.9408 51.3324 25.4151 51.8566 24.7698 51.8566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterLuck);
export default __webpack_public_path__ + "static/media/better-luck.a90b3ee5d030111c4d1157bc0c11b2d6.svg";
export { ForwardRef as ReactComponent };